import { useAppContext } from '../../Services/AppContext';
import { CaseEntry } from './CaseChatEntry';
import CaseChatEntryFileProcessing from './CaseChatEntryFileProcessing';
import CaseChatEntryFileInfected from './CaseChatEntryFileInfected';
import FirstUpper from '../FirstUpper';
import ECardAddFileModal from '../../Modules/Ecard/Components/ECardAddFile/ECardAddFileModal';
import CaseChatEntryFileToDocumentationModal from './CaseChatEntryFileToDocumentationModal';
import { useState } from 'react';
import MediaViewerModal from '../MediaViewer/MediaViewerModal';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';

interface CaseChatEntryFileProps {
	entry: CaseEntry;
	beforeChange: () => void;
	afterChange: () => void;
}

export default function CaseChatEntryFile(props: CaseChatEntryFileProps) {
	const { translation, socketUrl } = useAppContext();
	const { entry, beforeChange, afterChange } = props;
	const [moveToDocumentationModalOpened, setMoveToDocumentationModalOpened] =
		useState(false);
	const [mediaViewerOpened, setMediaViewerOpened] = useState(false);

	const handleShowMediaViewer = () => {
		setMediaViewerOpened(true);
	};

	const handleModalClose = () => {
		setMoveToDocumentationModalOpened(false);
		afterChange();
	};

	const handleMoveToDocumentation = () => {
		setMoveToDocumentationModalOpened(true);
	};

	if (entry.avResult === 'unprocessed' || !entry.avResult) {
		return <CaseChatEntryFileProcessing />;
	}

	if (entry.avResult === 'infected' || entry.avResult === 'other') {
		return <CaseChatEntryFileInfected />;
	}

	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];

	const fileType =
		imageExtensions.indexOf(entry.file.extension) !== -1
			? 'image'
			: entry.file.extension === 'pdf'
			? 'pdf'
			: 'none';

	const fileToViewer = {
		id: entry.fileId,
		name: entry.message,
		displayName: entry.message,
		type: fileType,
		preview:
			socketUrl +
			'/cases/' +
			entry.caseId +
			'/message/' +
			entry.fileId +
			'/preview',
		download:
			socketUrl +
			'/cases/' +
			entry.caseId +
			'/message/' +
			entry.fileId +
			'?download=1',
	};

	if (entry.thumb || entry.hasThumb) {
		const thumbUrl =
			entry.thumbUrl ||
			socketUrl +
				'/cases/' +
				entry.caseId +
				'/message/' +
				entry.fileId +
				'/preview';

		return (
			<div className='chat-message__message'>
				<div className='message-photo'>
					<a onClick={handleShowMediaViewer} style={{ cursor: 'pointer' }}>
						<div
							className='message-photo__image'
							style={{ backgroundImage: 'url(' + thumbUrl + ')' }}
						/>
					</a>
				</div>
				{!entry.inDocumentation && (
					<a
						className='btn-link blue'
						style={{ marginBottom: 0 }}
						onClick={handleMoveToDocumentation}>
						<FirstUpper>
							{translation['base.saveToHealthDocumentation']}
						</FirstUpper>
					</a>
				)}
				<CaseChatEntryFileToDocumentationModal
					opened={moveToDocumentationModalOpened}
					entry={entry}
					onClose={handleModalClose}
				/>
				<MediaViewerModal
					opened={mediaViewerOpened}
					onClose={() => setMediaViewerOpened(false)}
					file={fileToViewer}
				/>
			</div>
		);
	}

	return (
		<div className='chat-message__message'>
			<div>
				<a onClick={handleShowMediaViewer} style={{ cursor: 'pointer' }}>
					<i className='fa fa-file'></i> {entry.message}
				</a>
			</div>
			{!entry.inDocumentation && (
				<a
					className='btn-link blue'
					style={{ marginBottom: 0 }}
					onClick={handleMoveToDocumentation}>
					<FirstUpper>
						{translation['base.saveToHealthDocumentation']}
					</FirstUpper>
				</a>
			)}
			<CaseChatEntryFileToDocumentationModal
				opened={moveToDocumentationModalOpened}
				entry={entry}
				onClose={handleModalClose}
			/>
			<MediaViewerModal
				opened={mediaViewerOpened}
				onClose={() => setMediaViewerOpened(false)}
				file={fileToViewer}
			/>
		</div>
	);
}
